import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/index';
import { BackendAPIService } from '../../core/backend-api.service';
import { EscalatingReportSearchParams } from '../../reports/missed-recall/state/missed-recall-report.model';

@Injectable({
    providedIn: 'root'
})

export class EscalatingReportService {

    constructor(private httpClient: HttpClient) {
    }

    getEscalatingReport(searchParameters: EscalatingReportSearchParams): Observable<any> {
        return this.httpClient
            .get(`servlets/messages/${searchParameters.jobId}/escalatestats/${searchParameters.dateFrom}/`, {observe: 'body'});
    }
}
